"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDeAmountInWordsTamperProof = exports.TAMPER_PROOF_MARKER = exports.formatDeAmountInWords = exports.convertNumberToGermanWords = void 0;
const de_DE_1 = require("n2words/de-DE");
const convertNumberToGermanWords = (value) => {
    if (!Number.isFinite(value) || value < 0) {
        return "";
    }
    return (0, de_DE_1.toCardinal)(Math.floor(value));
};
exports.convertNumberToGermanWords = convertNumberToGermanWords;
const formatDeAmountInWords = (amountInCents) => {
    if (!Number.isFinite(amountInCents) || amountInCents < 0) {
        return "";
    }
    const totalCents = Math.round(amountInCents);
    const euros = Math.floor(totalCents / 100);
    const cents = totalCents % 100;
    return (0, de_DE_1.toCurrency)(`${euros}.${String(cents).padStart(2, "0")}`);
};
exports.formatDeAmountInWords = formatDeAmountInWords;
exports.TAMPER_PROOF_MARKER = "X";
const formatDeAmountInWordsTamperProof = (amountInCents) => {
    const words = (0, exports.formatDeAmountInWords)(amountInCents);
    if (!words) {
        return "";
    }
    return `${exports.TAMPER_PROOF_MARKER} ${words} ${exports.TAMPER_PROOF_MARKER}`;
};
exports.formatDeAmountInWordsTamperProof = formatDeAmountInWordsTamperProof;
